import {
    TGetCartApiParams,
    TGetCartApiResponse,
    TAddCartApiParams,
    TAddCartApiBody,
    TExtCartApiParams,
    TDelCartApiParams,
    TCartItem,
    TGetCartPromoApiParams,
    TAddCartPromoApiParams,
    TAddCartPromoApiBody,
    TDelCartPromoApiParams,
} from '@/domain/Cart.domain';

export enum ECartActionType {
    GET_CART = 'GET_CART',
    ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART',
    EXTEND_TIME_FOR_CART = 'EXTEND_TIME_FOR_CART',
    DELETE_ITEM_FROM_CART = 'DELETE_ITEM_FROM_CART',
    ADD_PROMO_CODE_TO_CART = 'ADD_PROMO_CODE_TO_CART',
    DELETE_PROMO_CODE_FROM_CART = 'DELETE_PROMO_CODE_FROM_CART',
    GET_TIPS = 'GET_TIPS',
}

export type TCartState = {
    cart_id: string;
    cart: TGetCartApiResponse | null;
    removedCartItems: TCartItem[];
    expiredCartItems: TCartItem[];
    loading: { actionType: ECartActionType; state: boolean };
    error: { actionType: ECartActionType; message: string };
    success: { actionType: ECartActionType; message: string };
    tips: number;
    cartToastIsShown: boolean;
};

export type TCartActions = {
    getCart: (
        params: Omit<TGetCartApiParams, 'id'>,
        actionType: ECartActionType,
        newItemIds?: string[]
    ) => Promise<TGetCartApiResponse | null>;
    addCart: (
        params: Omit<TAddCartApiParams, 'id'>,
        body: TAddCartApiBody,
        showToast?: boolean
    ) => Promise<{ success: { actionType: ECartActionType; message: string } }>;
    extCart: (params: Omit<TExtCartApiParams, 'id'>) => void;
    delCart: (params: Omit<TDelCartApiParams, 'id'>) => void;
    clearError: (actionType: ECartActionType) => void;
    clearSuccess: (actionType: ECartActionType) => void;
    setEmptyCart: () => void;
    handleRemovedCartItemsChange: (cartItemId: string) => void;
    resetRemovedCartItems: () => void;
    setExpiredCartItems: (cartItems: TCartItem[]) => void;
    getCartPromo: (params: Omit<TGetCartPromoApiParams, 'id'>, actionType: ECartActionType) => void;
    addCartPromo: (params: Omit<TAddCartPromoApiParams, 'id'>, body: TAddCartPromoApiBody) => void;
    delCartPromo: (params: Omit<TDelCartPromoApiParams, 'id'>) => void;
    getTips: (partnerId: Omit<TAddCartApiParams, 'id'>['partnerId']) => void;
    showThenHideCartToast: () => void;
};

export type TCartStore = TCartState & TCartActions;
